<template>
    <settings-editor-base
        v-bind:label="label"
        v-bind:tooltip="tooltip"
    >
        <template v-slot="{inputId}">
            <textarea
                    v-bind:id="inputId"
                    v-bind:value="value"
                    @input="$emit('input', $event.srcElement.value)"
                    class="form-control"
                    v-bind:cols="cols"
                    v-bind:rows="rows"
            >
                
            </textarea>
        </template>
    </settings-editor-base>
</template>

<script>
    import SettingsEditorBase from "./SettingsEditorBase.vue";
    
    export default {
        name: "settings-text-area",
        components: {SettingsEditorBase},
        props: {
            label: {
                type: String,
                required: true
            },
            tooltip: String,
            cols: Number,
            rows: Number,
            value: String
        }
    };
</script>
